<template>
  <div class="contactinfoform">
    <p v-if="(profile.preferredContactMethod == 'letter' || profile.preferredContactMethod == '') && profile.email==''">Vi kommer fortsättningsvis endast skicka information via e-post. Du har ingen e-postadress hos oss idag och måste därför lägga in den nedan.<br /><br /></p>

    <div v-if="showContact" class="contactinfoform--name">{{who}}</div>
    <div v-if="showContact">{{profile.postalAddress}}<br />{{profile.zipCode}} {{profile.city}}</div>
    <div v-if="!editProfile">
      <div v-if="showContact">
        <div v-if="profile.phoneMobile">Telefon mobil: {{profile.phoneMobile}}</div>
        <div v-if="profile.phoneHome">Telefon hem: {{profile.phoneHome}}</div>
        <div v-if="profile.phoneMobile2">Telefon: {{profile.phoneMobile2}}</div>
        <div v-if="profile.phoneMobile3">Telefon arbete: {{profile.phoneMobile3}}</div>
        <div v-if="profile.phoneWork">Telefon arbete: {{profile.phoneWork}}</div>
        <div v-if="profile.email">{{profile.email}}</div>
        <a class="contactinfoform__link" @click="editProfile=true" @keyup.enter="editProfile=true" tabindex="0">Ändra uppgifter</a>
      </div>

    </div>
    <div v-if="editProfile">
      <form class="profileform" @submit.prevent="submit()">
        <div class="contactinfoform__profileform__input-field" v-if="profile.preferredContactMethod == 'letter' || profile.preferredContactMethod== ''">
          <label>Föredraget kontaktsätt:</label><br />
          <RadioButton
            id="email"
            label="E-post"
            name="preferredContactMethod"
            v-model="preferredContactMethod"
            disabled="true"
            value="email"
          />
        </div>

        <h3 class="mt-2" v-if="editableProfile.email==''">Vi saknar en e-post till dig</h3>
        <div class="contactinfoform__profileform__input-field">
            <Input
              id="email"
              :rule-type="'required|email'"
              label="E-postadress"
              v-model="editableProfile.email"
              type="text"
              placeholder=""
              :floatingLabel="true"
            />
        </div>

        <div class="contactinfoform__profileform__input-field">
          <div v-if="editableProfile.phoneMobile">
            <Input
              id="phoneMobile"
              label="Telefon mobil"
              v-model="editableProfile.phoneMobile"
              type="text"
              placeholder=""
              :floatingLabel="true"
            />

          </div>
        </div>

        <div class="contactinfoform__profileform__input-field">
          <div v-if="profile.phoneHome">
            <Input
              id="phoneHome"
              label="Telefon hem"
              v-model="editableProfile.phoneHome"
              type="text"
              placeholder=""
              :floatingLabel="true"
            />

          </div>
        </div>
        <div class="contactinfoform__profileform__input-field">
          <div v-if="profile.phoneMobile2">
            <Input
              id="phoneMobile2"
              label="Telefon"
              v-model="editableProfile.phoneMobile2"
              type="text"
              placeholder=""
              :floatingLabel="true"
            />
          </div>
        </div>
        <div class="contactinfoform__profileform__input-field">
          <div v-if="profile.phoneMobile3">
            <Input
              id="phoneMobile3"
              label="Telefon"
              v-model="editableProfile.phoneMobile3"
              type="text"
              placeholder=""
              :floatingLabel="true"
            />


          </div>
        </div>

        <Button :disabled="!editProfile || showLoader" variant="primary" tabindex="0" size="small" type="submit" @click="submit()" :loading="showLoader" loadingText="Sparar">Spara</Button>
        <a @click="editProfile=false; this.$emit('done');" tabindex="0" class="contactinfoform__form__cancel">Avbryt</a>
      </form>
    </div>
  </div>

</template>

<script>
import { dataLayerPush } from '@/helpers/datalayer'
import Loader from '@/components/ui/loader'
import { mapGetters } from 'vuex'
import Input from '@/components/ui/form/input';
import RadioButton from '@/components/ui/form/radio';
import Button from '@/components/ui/button';

export default {
  emits: ['done'],
  components: {
    Loader,
    Input,
    RadioButton,
    Button
  },

  data () {
    return {
      preferredContactMethod: "email",
      showLoader: false,
      editableProfile: {},
      disabled: false,
      isSubmitting: false,
      editProfile: false
    }
  },

  props: {
    showContact: {
      type: Boolean,
      default: true
    },
    editProfilePreset: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    addSpace (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    submit () {
          this.showLoader = true;
          if (this.editableProfile.email == '') delete this.editableProfile.email;
          this.editableProfile.preferredContactMethod = 'email';

          return this.$store.dispatch('saveProfile', this.editableProfile).then(() => {
            return this.$store.dispatch('fetchProfile')
          }).then((profile) => {
            this.editProfile = false;
            this.$emit('done');
          }).finally(() => {
            this.showLoader = false;

          }).catch((err) => {
            this.showLoader = false;
            const emailError = err.response.data.errors.find(x => x.field === 'email');
            if(emailError && emailError.code === "alreadyExists") {
              this.$validator.errors.add({
                field: 'email',
                msg: "Det finns redan ett konto där e-posten används, vänligen försök igen.",
              });
            }});

    },
    isDefaultNumber: function(el){
      if(el.target.value === "" && el.target.name == this.editableProfile.defaultPhone){
        if(this.editableProfile.phoneMobile !== ""){
          this.editableProfile.defaultPhone = 'phoneMobile';
        }
        else if(this.editableProfile.phoneHome !== ""){
          this.editableProfile.defaultPhone = 'phoneHome';
        }
        else if(this.editableProfile.phoneMobile2 !== ""){
          this.editableProfile.defaultPhone = 'phoneMobile2';
        }
        else if(this.editableProfile.phoneMobile3 !== ""){
          this.editableProfile.defaultPhone = 'phoneMobile3';
        }
        else(
            this.editableProfile.defaultPhone = ''
          )
      }
    },
  },

  watch: {
    profile: {
      deep: true,
      immediate: true,
      handler (profile) {
        this.editableProfile = { ...profile };
      }
    }
  },

  computed: {
    ...mapGetters({
      profile: 'profile',
      address: 'address'
    }),

    isNumberRequired(){
      if(this.editableProfile.phoneMobile !== "" || this.editableProfile.phoneHome !== "" || this.editableProfile.phoneMobile2 !== "" || this.editableProfile.phoneMobile3 !== "" || !!this.editableProfile.phoneWork)
        return ''

      else
        return 'required';
    },

    who () {
      const profile = this.$store.getters.profile;

      if (!profile || !profile.firstName) {
        if (profile && profile.companyName) return profile.companyName;
        else return '';
      }

      return profile.firstName + ' ' + profile.lastName;
    },
  },

  created () {
    if (this.editProfilePreset) this.editProfile = this.editProfilePreset;
    return Promise.all([
      this.$store.cache.dispatch('fetchProfile'),
    ]).finally(() => {
      if(this.$store.getters.profile.preferredContactMethod == 'letter' || this.$store.getters.profile.preferredContactMethod == '' || this.$store.getters.profile.email == '') this.editProfile = true;
    })
  }
}

</script>

<style lang="scss" scoped>
.contactinfoform {

  input {
    width: 100%;
    margin-top: 7px;
    margin-bottom: 8px;
    padding: 7.5px 10px;
    background: #fff;
    border: 1px solid #f0f0f0;
    font-size: 1.4rem;
    line-height: 1.6;
    outline: none;
    transition: box-shadow .15s linear;

    &:not(:focus).is-danger {
      border-color: #D32F2F !important;
    }

    &:disabled {
      background-color: $lightgray;
    }

    &[type=checkbox] {
      width: 20px;
      height: 20px;
      box-shadow: none;
      accent-color: #007893;
    }

    &[type="radio"] {
      width: fit-content;
      display: block !important;
      accent-color: #007893;
      margin-right: 8px;

      &:checked+label {
        background: transparent !important;
      }
    }

  }

  &__info {
    font-size: 14px;
    line-height: 1.6;

    &--missingmail {
      display: flex;
      align-items: flex-start;


      button {
        margin-top: 5px;
        margin-bottom: 0;
        margin-left: 16px;
      }
    }


    &--email {
      h3 {
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
        margin-top: 20px;
      }

      ::placeholder {
        font-size: 18px;
        color: #9d9d9c;
      }

      &--disclaimer {
        display: block;
        font-size: 12px;
        margin-top: 4px;
        text-align: center;
      }

      input {
        width: 100%;
        max-width: 100%;
      }
    }
  }

  &__link {
    display: block;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    text-align: right;
    color: #007893
  }

  &__profileform {
    &__input-field {
      margin-top: 10px;
    }
  }

  &__form {
    &__submit {
      margin-right: 10px;
      margin-top: 15px;
      cursor: pointer;
      padding: 10px 22px;
      border-radius: 6px;
      border: solid 2px #007893;
      color: #fff;
      text-transform: none;
      font-weight: bold;
      font-size: 14px;
      font-family: "proxima-nova", sans-serif;
      background-color: #007893;
      margin-bottom: 16px;
      text-decoration: none;
      transition: all 0.3s;
      outline: none;

      &:hover, &:active, &:focus {
        background-color: #00667d;
        box-shadow: none;
      }

      &:disabled {
        cursor: default;
        color: #fff;
        background-color: #9d9d9c;
        border: solid 2px #9d9d9c;
      }
    }
    &__cancel {
      margin-left: 8px;
      cursor: pointer;
    }
  }


  &__contact {
    position: relative;
    padding: 27px 34px 24px 20px;
    background: #F9F9F9;
    border: 1px solid #e9e9e9;
    border-radius: 6px;

    &__heading {
      font-weight: bold;
      font-size: 18px
    }

    &__info {
      font-size: 14px;
      line-height: 1.6;
    }

    &__link {
      position: absolute;
      font-weight: bold;
      font-size: 14px;
      bottom: 20px;
      right: 33px;
      cursor: pointer;
      color: #007893
    }
  }

  h3, &__title {
    font-weight: bold !important;
  }

  h4 {
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #00667d;
    padding-bottom: 0;
  }

  p {
    font-size: 14px;
  }

  &__confirm {
    margin-top: 24px;
  }

  &__submit {
    margin-right: 10px;
    margin-top: 15px;
    cursor: pointer;
    padding: 16px 42px;
    border-radius: 6px;
    border: solid 2px #007893;
    color: #fff;
    text-transform: none;
    font-weight: bold;
    font-size: 18px;
    font-family: "proxima-nova", sans-serif;
    background-color: #007893;
    margin-bottom: 16px;
    text-decoration: none;
    transition: all 0.3s;
    outline: none;
    width: 100%;


    @media (min-width: 800px) {
      width: auto;
    }


    &:hover, &:active {
      background-color: #00667d;
    }

    &:disabled {
      cursor: default;
      border-color: #9d9d9c;
      background-color: #9d9d9c;

      &:hover, &:active {
        background-color: #9d9d9c;
      }
    }
  }
}
</style>
